import api from './api';

const regionalService = {
  // Regionais CRUD
  getAllRegionais: async () => {
    const response = await api.get('/regional');
    return response.data.data;
  },

  getRegionalById: async (id) => {
    const response = await api.get(`/regional/${id}`);
    return response.data.data;
  },

  createRegional: async (data) => {
    const response = await api.post('/regional', data);
    return response.data.data;
  },

  updateRegional: async (id, data) => {
    const response = await api.put(`/regional/${id}`, data);
    return response.data.data;
  },

  deleteRegional: async (id) => {
    const response = await api.delete(`/regional/${id}`);
    return response.data.data;
  },

  // Gerenciamento de Associação com Municípios
  getMunicipiosOfRegional: async (regionalId) => {
    const response = await api.get(`/regional/${regionalId}/municipios`);
    return response.data.data;
  },

  addMunicipioToRegional: async (regionalId, municipioId) => {
    const response = await api.post(`/regional/${regionalId}/municipios`, { municipioId });
    return response.data.data;
  },

  removeMunicipioFromRegional: async (regionalId, municipioId) => {
    const response = await api.delete(`/regional/${regionalId}/municipios/${municipioId}`);
    return response.data.data;
  },
};

export default regionalService;